import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';
// layouts
import ReservationLayout from 'src/layouts/reservation/reservation';
// components
import { SplashScreen } from 'src/components/loading-screen';
// auth
import { GuestGuard } from 'src/auth/guard';

// ----------------------------------------------------------------------

const Reservation = lazy(() => import('src/pages/training/reservation'));


// ----------------------------------------------------------------------

export const reservationRoutes = [
  {
    path: 'reservations',
    element: (
      <GuestGuard>
        <Suspense fallback={<SplashScreen />}>
          <Outlet />
        </Suspense>
      </GuestGuard>
    ),children: [
      {
        path: 'trainings/:trainingID',
        element: (
          <ReservationLayout>
            <Reservation />
          </ReservationLayout>
        ),
      },
    ],
  }
];

